module.exports = __webpack_public_path__ + "static/media/throne.fe266974.png";